import { createFileRoute } from '@tanstack/react-router'
import OrgInviteLandingPage from '@/pages/org-invites'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/org-invites/$token')({
  // Invitations are hidden while Laplace x GTM is single-user.
  beforeLoad: ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
  },
  component: OrgInviteLandingPage,
  staticData: { layout: 'public' },
})
